export const USDC_E_CONTRACT_ADDRESS = '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174' as const

// Native USDC on Polygon (Circle's native implementation)
export const USDC_NATIVE_CONTRACT_ADDRESS = '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359' as const

export const USDC_E_DECIMALS = 6
export const USDC_DECIMALS = 6

// V2 collateral — pUSD (Polymarket USD), ERC-20 backed 1:1 by USDC.
// Source: https://docs.polymarket.com/resources/contracts
export const PUSD_CONTRACT_ADDRESS = '0xC011a7E12a19f7B1f670d46F03B03f3342E82DFB' as const
export const PUSD_DECIMALS = 6

// Collateral Onramp — wraps USDC.e → pUSD via wrap(asset, to, amount).
// Source: https://docs.polymarket.com/concepts/pusd
export const COLLATERAL_ONRAMP_CONTRACT_ADDRESS =
	'0x93070a847efEf7F70739046A929D47a521F5B8ee' as const

// CtfCollateralAdapter — V2 wrapper around bare ConditionalTokens. Pulls
// pUSD, converts to ctfCollateral (USDC.e) via Collateral Onramp, then
// calls into bare CTF to mint outcome tokens in the V2 namespace.
// Source: https://docs.polymarket.com/resources/contracts
//
// Updated 2026-05-04: Polymarket announced new CtfCollateralAdapter
// addresses on May 1 (relayer events structure addition). The old
// 0xADa100874d… address is blocked by the relayer allowlist post-cutoff,
// confirmed via local repro on the deposit wallet upgrade flow:
//   "call blocked: call[0] blocked: approve spender
//    0xADa100874d00e3331D00F2007a9c336a65009718 is not in the allowed list"
export const CTF_COLLATERAL_ADAPTER_ADDRESS = '0xAdA100Db00Ca00073811820692005400218FcE1f' as const

// NegRiskCtfCollateralAdapter — V2 wrapper around bare NegRiskAdapter.
// Same role as CtfCollateralAdapter but for negative-risk markets.
// Pulls pUSD, converts to the neg-risk wrapped ctfCollateral
// (0x3a3bd7bb…002e2 per NegRisk-Exchange.getCtfCollateral()), then
// calls into bare NegRiskAdapter.
//
// Updated 2026-05-04: same May 1 announcement bumped this contract too.
// Old 0xAdA200001000… address replaced with the new allowlisted one.
export const NEG_RISK_CTF_COLLATERAL_ADAPTER_ADDRESS =
	'0xadA2005600Dec949baf300f4C6120000bDB6eAab' as const

export const CTF_CONTRACT_ADDRESS = '0x4d97dcd97ec945f40cf65f87097ace5ea0476045' as const

// V1 Exchange contracts — dead after April 28 2026 ~11:00 UTC cutover.
// Kept for reference until V1 callsites are removed. Do not add new uses.
export const CTF_EXCHANGE_ADDRESS = '0x4bFb41d5B3570DeFd03C39a9A4D8dE6Bd8B8982E' as const

export const NEG_RISK_CTF_EXCHANGE_ADDRESS = '0xC5d563A36AE78145C45a50134d48A1215220f80a' as const

export const NEG_RISK_ADAPTER_ADDRESS = '0xd91E80cF2E7be2e162c6513ceD06f1dD0dA35296' as const

// Treasury wallet for platform fees - configured via environment variable
// Falls back to a safe default (null address) if not set, which disables fees
export const TREASURY_WALLET_ADDRESS = (process.env.NEXT_PUBLIC_TREASURY_WALLET_ADDRESS ||
	'0x0000000000000000000000000000000000000000') as `0x${string}`

// Platform fee configuration
// TODO: TEMPORARY OVERRIDE — 0% fees for everyone. Restore to 0.0025 for 0.25% fee.
export const DEFAULT_FEE_RATE = 0
/** @deprecated Use DEFAULT_FEE_RATE and user-specific rates instead */
export const PLATFORM_FEE_PERCENT = DEFAULT_FEE_RATE
